import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'
import FormatTableFieldUtils from '../../../../../common/utils/format-table-field-util'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as DataTypeConstants from '../../../../../constants/DataTypeConstants'

export default {
  getMemberConsumption: ({ commit }, data) => {
    pointsMailApi.getMemberConsumption(data)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'changeType',
            fieldPropName: 'changeTypeName',
            fieldFormatParam: DictionaryConstants.MY_POINTS_TYPE
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'payType',
            fieldPropName: 'payTypeName',
            fieldFormatParam: DictionaryConstants.PAY_TYPE
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'cardDefinitionId',
            fieldPropName: 'cardDefinitionIdName',
            fieldFormatParam: DictionaryConstants.MY_CARD_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result.dataList, params).then(res => {
          result.dataList = res
          commit(types.MY_CONSUMPTION_LIST, result)
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/records-of-consumption/store/actions.js